const URL = {
  MAIN: "/",

  LOGIN: "/login",
  LOGIN_GOOGLE: "/login/google",
  SIGNUP: "/signup",
  LOGOUT: "/logout",

  REGISTER: "/register",
  CHECK_NICKNAME: "/register/verify",

  MYPAGE: "/mypage",
  CHANGE_NICKNAME: "/mypage/change-nickname",

  POSTS: "/posts",
  POST_DETAIL: "/posts/detail",
  POST_CREATE: "/posts/create",
  POST_EDIT: "/posts/edit",
  POST_DELETE: "/posts/delete",
  COMMENT: "/posts/comment",
  LIKE: "/posts/like",
  POPULAR: "/posts/popular",
};

export default URL;
